import React from "react";
import { BsPlusCircleFill } from "react-icons/bs";
import "./Icons.scss";
const AddIcon = ({ className }) => {
  return (
    <>
      <button type="button" className="add-documents-button">
        <BsPlusCircleFill className={className} />
      </button>
    </>
  );
};

export default AddIcon;
